const endpoints = {

  auth: {
    login: "/users/login/",
    logout: "/users/logout/",
    sendOtp: "/users/login-with-otp/",
    verifyOtp: "/users/login-with-otp-verify/",
    onboarding: "/users/onboarding/",  
    doctorAccountCreate: "/doctor/doctor-account-create/",
  },

  doctor: {
    profile: "/doctor/profile/",
    documents: "/doctor/documents/",
    documentDetail: (id) => `/doctor/document-detail/${id}/`,
  },

  library: {
    verifyQrOtp: (otp) => `/library/verify-qr-otp/?otp=${otp}`,
    folderFiles: "/library/view-files-of-folder/",
  },

  subscribe: {
    subscribe: "/users/mail-subscribe/",
    unsubscribe: "/users/mail-unsubscribe/",
  },
  
};

export default endpoints;